var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEfficient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4915 20.6274C35.6253 30.3618 41.5378 18.8615 44.755 12.2564C41.332 11.9718 27.5873 2.27593 24.6743 17.7343",
    stroke: "#0068B5",
    strokeWidth: 1.5907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6244 15.0364C31.7211 15.6167 26.5195 18.4141 22.9414 23.6933",
    stroke: "#0068B5",
    strokeWidth: 1.5907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5674 44.0245C16.5674 44.0245 20.7569 43.6045 21.6646 43.6045C22.5723 43.6045 31.0179 42.6923 32.7488 42.0125C33.3115 41.7578 39.395 38.2992 39.395 38.2992L43.5865 32.9952C44.2566 32.1427 44.4992 31.0479 43.9792 30.2426C43.5606 29.5566 42.8866 29.1129 41.3466 29.2919C39.6674 29.4882 38.3004 31.7413 38.3004 31.7413L35.4461 32.5205",
    stroke: "#0068B5",
    strokeWidth: 1.5907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5674 32.0942C16.5674 32.0942 19.0966 32.6025 19.9268 31.6406C20.9667 30.3718 21.7501 30.0785 23.8757 28.8618C25.7308 27.7993 27.251 28.11 27.8534 28.3747C28.4559 28.6394 29.3696 28.9265 30.0168 28.8954C31.0299 28.8469 32.727 28.6456 33.8623 28.8693C35.3556 29.1638 35.6051 31.2553 35.4461 32.5229C35.2333 33.8937 33.2936 34.4231 31.7318 34.6604C30.1699 34.8978 28.6359 35.1314 28.6359 35.1314",
    stroke: "#0068B5",
    strokeWidth: 1.5907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7954 29.1104L16.5675 29.134L16.5466 47.0058H11.7954",
    stroke: "#0068B5",
    strokeWidth: 1.5907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.5501,
    height: 40,
    fill: "white",
    transform: "translate(11 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEfficient);
export default __webpack_public_path__ + "static/media/icon_efficient.7d41a6ea77ffbc27f510fdf138fa4633.svg";
export { ForwardRef as ReactComponent };